<template>
  <div class="filter-item">
    <div class="md-layout">
      <md-datepicker v-model="value" @input="changeFilter">
        <label>дата создания по</label>
      </md-datepicker>
    </div>
    <div class="loading-overlay" v-if="loadStatus">
      <md-progress-spinner :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dateTo',
  data () {
    return {
      items: [],
      value: null,
      loadStatus: false
    }
  },
  methods: {
    changeFilter () {
      let val = null
      if (!this.value) {
        this.value = null
      } else {
        val = this.value
        val.setHours(23)
        val.setMinutes(59)
        val.setSeconds(59)
      }
      if (val !== null && this.$store.state.filters['createdAtTo'] !== null && typeof (val) === 'object' && typeof (this.$store.state.filters['createdAtTo']) === 'object' &&
        val.toString() === this.$store.state.filters['createdAtTo'].toString()) {
        return
      }
      this.$store.commit('setFilter', {name: 'createdAtTo', value: val})
      this.$emit('changeFilter')
    },
    startLoading () {
      this.loadStatus = true
    },
    stopLoading () {
      this.loadStatus = false
    }
  },
  created () {
    if (this.$store.state.filters['createdAtTo'] && this.value === null) {
      this.value = this.$store.state.filters['createdAtTo']
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/registrationRequests/list/filters/dateTo.vue